//#region src/integrations/moonshot/moonshotTypes.ts
const MOONSHOT_INTEGRATION_ID = "moonshot";
const MOONSHOT_DEFAULT_BASE_URL = "https://api.moonshot.ai/anthropic";
const MOONSHOT_DEFAULT_API_BASE_URL = "https://api.moonshot.ai";
const MOONSHOT_LOGO_URL = "/logos/moonshot/logo.png";

//#endregion
export { MOONSHOT_DEFAULT_API_BASE_URL, MOONSHOT_DEFAULT_BASE_URL, MOONSHOT_INTEGRATION_ID, MOONSHOT_LOGO_URL };
//# sourceMappingURL=moonshotTypes.js.map